import React from "react";
import { Zap, SunMedium, Wrench, LayoutPanelTop } from "lucide-react";
import { services } from "../mock";

const iconMap = { Zap, SunMedium, Wrench, LayoutPanelTop };

const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F5B800] font-semibold tracking-widest text-sm uppercase">What We Do</p>
          <h2 className="mt-2 text-3xl md:text-4xl font-extrabold text-[#0f2a5c] underline-yellow">
            Our Services
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div
                key={s.id}
                className="card-hover bg-white rounded-2xl shadow-[0_6px_20px_-8px_rgba(15,42,92,0.15)] border border-slate-100 overflow-hidden flex flex-col"
              >
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div
                    className="absolute left-1/2 -bottom-6 -translate-x-1/2 w-14 h-14 rounded-full flex items-center justify-center shadow-lg border-4 border-white"
                    style={{ backgroundColor: s.iconBg }}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                </div>
                <div className="px-5 pt-10 pb-6 text-center">
                  <h3 className="text-lg font-bold text-[#0f2a5c]">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
